import { faCircle, faCircleCheck, faCircleDot, faCircleExclamation, faOctagonXmark } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cx from 'classnames';

import * as style from './style.module.css';

export const InputRadio = ({
    name = '',
    checked = false,
    onChange = () => {},
    onBlur = () => {},
    onFocus = () => {},
    mode = 'normal',
    disabled = false,
}) => {
    const getIcon = () => {
        if (mode === 'normal') {
            return checked ? faCircleDot : faCircle;
        }
        if (mode === 'correct') {
            return faCircleCheck;
        }
        if (mode === 'error') {
            return faOctagonXmark;
        }
        if (mode === 'warning') {
            return faCircleExclamation;
        }
        return faCircle;
    };

    return (
        <label>
            <input
                type="radio"
                name={name}
                checked={checked}
                disabled={disabled}
                className={style.input}
                onChange={onChange}
                onBlur={onBlur}
                onFocus={onFocus}
            />
            <div className={cx(style.iconcontainer, { [style.disabled]: disabled })}>
                <FontAwesomeIcon className={cx(style[mode], { [style.selected]: checked })} icon={getIcon()} />
            </div>
        </label>
    );
};
